import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';

export const ExpiredButton = ({ isActive, count, loading, onClick, title }) => {
  const frg = isActive ? 'white' : 'red';
  const bkg = isActive ? 'red' : 'white';
  return (
    <Tooltip
      title={title}
      placement="bottom"
    >
      <Button
        shape="round"
        icon="fire"
        style={{ color: frg, background: bkg, marginRight: '10px' }}
        type="danger"
        disabled={!count}
        loading={loading}
        onClick={onClick}
      >
        {!loading && <span style={{ fontWeight: 'bold' }}>{count} </span>}
      </Button>
    </Tooltip>
  );
};

ExpiredButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
